import MaskedInput from 'react-text-mask';
import React from 'react';
import InputHelper from '../../helpers/input_helper';

const DobFormatInput = ({ inputRef, onChange, name, id, ...other }) => {
  return (
    <MaskedInput
      {...other}
      id={id}
      mask={[/\d/, /\d/, '/', /\d/, /\d/, '/', /\d/, /\d/, /\d/, /\d/]}
      placeholderChar={'\u2000'}
      onChange={(e) =>
        onChange({
          target: {
            name,
            id,
            value: e.target.value,
          },
          currentTarget: {
            name,
            id,
            value: e.target.value,
          },
        })
      }
      onKeyDown={(e) => InputHelper.handleMaskedBackspace(e, '/')}
      guide={false}
      keepCharPositions={false}
      inputMode="numeric"
    />
  );
};

export default DobFormatInput;
